import React from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import items from "../../../constants/index/hero";
import styled from "styled-components";
import circle from "../../../assets/images/circle.png";

const Hero = () => {
  return (
    <Wrapper>
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView="auto"
        navigation
        pagination={{ clickable: true }}
        className="heroSwiper"
      >
        {items.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div
                className="container-hero"
                style={{
                  backgroundImage: `linear-gradient(
                    90deg,
                    #5268c2,
                    rgb(11 10 10 / 0%),
                    rgb(11 10 10 / 0%)
                  ),url(${item.bg})`,
                }}
              >
                <div className="col-md-12 slide">
                  <div className="col-md-8 col-lg-5">
                    <h2>{item.title}</h2>
                    <h1>{item.subtitle}</h1>
                    <p>{item.text}</p>
                    <a href="#" className="btn btn-warning">
                      Cotiza tu seguro
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Wrapper>
  );
};

export const Wrapper = styled.section`
  color: #fff;
  position: relative;
  &:after {
    content: "";
    background-image: none;
    height: 233px;
    width: 100%;
    bottom: -65px;
    left: -120px;
    position: absolute;
    background-repeat: no-repeat;
    background-size: contain;
    z-index: 1;
    @media (min-width: 768px) {
      background-image: url(${circle});
    }
  }

  .container-hero {
    padding: 100px 0 40px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 100px 0 70px;
    @media (min-width: 992px) {
      padding: 100px 0 160px;
    }
  }
  .slide {
    width: 90%;
    margin: auto;
  }
  h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 42px;
      text-align: left;
    }
  }

  h2 {
    border-bottom: 4px solid #fff;
    width: fit-content;
    font-size: 26px;
    padding-bottom: 6px;
    margin-bottom: 30px;
    font-weight: 600;
  }

  p {
    font-size: 17px;
    margin-bottom: 20px;
    text-align: center;
    width: 60%;
    margin: 0 auto 20px;
    @media (min-width: 992px) {
      font-size: 20px;
      text-align: left;
      margin: 0 0 20px;
      width: 90%;
    }
  }

  .btn {
    margin: 0 22% 20px !important;
    @media (min-width: 992px) {
      margin: 0 !important;
    }
  }

  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: transparent;
    border: 1px solid #fff;
    margin: 0 10px !important;
    height: 15px;
    width: 15px;
  }

  .swiper-pagination-bullet-active {
    background-color: #fff;
    border: 1px solid #fff;
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: #fff !important;
    visibility: hidden;
    @media (min-width: 992px) {
      visibility: visible;
    }
  }
`;

export default Hero;
